import actions from '@/actions';

export default function ai({ actions: actionsToDispatch, operation, product }) {
  actionsToDispatch.push(actions.bulkEdit.aiOperationGenerate({ operation, product }));

  return { actions: actionsToDispatch, product };
}
